import URL from '@helpers/url-constant';

// Sidebar navigation as data so the rail is easy to extend or reuse. `icon`
// keys into the map in ./icons; `match` controls active highlighting —
// 'startsWith' for a section that owns sub-routes (Dashboard), exact match
// otherwise.
export const NAV_SECTIONS = [
  {
    label: 'Menu',
    items: [
      {
        id: 'dashboard',
        label: 'Dashboard',
        href: URL.DASHBOARD,
        icon: 'dashboard',
        match: 'startsWith',
      },
      { id: 'campaigns', label: 'Manage Campaigns', href: URL.MANAGE_CAMPAIGNS, icon: 'campaigns' },
      { id: 'stores', label: 'Manage Stores', href: URL.MANAGE_STORES, icon: 'stores' },
      { id: 'terms', label: 'Manage T&Cs', href: URL.TERMS_AND_COND, icon: 'terms' },
    ],
  },
  {
    label: 'Account',
    items: [{ id: 'settings', label: 'Settings', href: URL.SETTINGS, icon: 'settings' }],
  },
];

export default NAV_SECTIONS;
